import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../shared-zorro.module';
import { RouterModule, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UserService } from '../../service/user.service';
import * as echarts from 'echarts';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.less',
})
export class DashboardComponent {
  data = [
    {
      id: '210115',
      mt: 'CT',
      bodypart: '胸部',
      uploadTime: '2024-10-23 11:23:58',
      action: '报告',
    },
    {
      id: '210116',
      mt: 'DR',
      bodypart: '腹部',
      uploadTime: '2024-10-23 11:23:58',
      action: '报告',
    },
    {
      id: '210117',
      mt: 'CT',
      bodypart: '头部',
      uploadTime: '2024-10-23 11:23:58',
      action: '报告',
    },
    {
      id: '210118',
      mt: 'MR',
      bodypart: '胸部',
      uploadTime: '2024-10-23 11:23:58',
      action: '报告',
    },
    {
      id: '210119',
      mt: 'DR',
      bodypart: '腹部',
      uploadTime: '2024-10-23 11:23:58',
      action: '报告',
    },
    {
      id: '210120',
      mt: 'CT',
      bodypart: '头部',
      uploadTime: '2024-10-23 11:23:58',
      action: '报告',
    },
    {
      id: '210121',
      mt: 'MR',
      bodypart: '胸部',
      uploadTime: '2024-10-23 11:23:58',
      action: '报告',
    },
    {
      id: '210122',
      mt: 'DR',
      bodypart: '腹部',
      uploadTime: '2024-10-23 11:23:58',
      action: '报告',
    },
    {
      id: '210123',
      mt: 'CT',
      bodypart: '头部',
      uploadTime: '2024-10-23 11:23:58',
      action: '报告+审核',
    },
  ];
  retrunData = [
    {
      reason: '错别字',
      count: 10,
      percent: 20,
    },
    {
      reason: '符号错误',
      count: 20,
      percent: 35,
    },
    {
      reason: '错标',
      count: 30,
      percent: 36,
    },
    {
      reason: '漏标',
      count: 40,
      percent: 15,
    },
    {
      reason: '左右写反',
      count: 1,
      percent: 1,
    },
  ];
  ngOnInit() {
    setTimeout(() => {
      this.setWorkChart();
      this.setMTChart();
    }, 0);
  }

  //设置echarts图表
  setWorkChart() {
    const workChart = echarts.init(document.getElementById('work-chart'));
    const option = {
      title: {
        text: '',
        left: 'center',
        textStyle: {
          color: '#fff',
        },
      },
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['报告量', '审核量'],
        textStyle: {
          color: '#fff',
        },
        top: '20px',
      },
      grid: {
        top: '60px',
        left: '0',
        right: '0',
        bottom: '10px',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        axisLine: {
          lineStyle: {
            color: '#ccc',
          },
        },
        axisLabel: {
          color: '#ccc',
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#ccc',
          },
        },
        axisLabel: {
          color: '#ccc',
        },
        splitLine: {
          lineStyle: {
            color: '#555',
            type: 'dashed',
          },
        },
      },
      series: [
        {
          name: '报告量',
          type: 'line',
          smooth: true,
          data: [200, 300, 150, 80, 70, 110, 130, 200, 250, 300, 400, 500],
          lineStyle: {
            color: 'red',
          },
          areaStyle: {
            color: 'rgba(255, 0, 0, 0.2)',
          },
          itemStyle: {
            color: 'red',
          },
        },
        {
          name: '审核量',
          type: 'line',
          smooth: true,
          data: [180, 250, 130, 90, 100, 120, 150, 170, 240, 290, 380, 460],
          lineStyle: {
            color: '#ccc',
          },
          areaStyle: {
            color: 'rgba(200, 200, 200, 0.2)',
          },
          itemStyle: {
            color: '#ccc',
          },
        },
      ],
    };
    workChart.setOption(option);
  }

  //设置设备类型图表
  setMTChart() {
    const deviceTypeChart = echarts.init(document.getElementById('mt-chart'));
    const option = {
      title: {
        text: '',
        left: 'center',
        textStyle: {
          color: '#fff',
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow', // 显示阴影
        },
      },
      grid: {
        top: '60px',
        left: '0',
        right: '0',
        bottom: '10px',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: ['DR', 'CT', 'MR', 'MG', 'NM', 'OT'],
        axisLine: {
          lineStyle: {
            color: '#ccc',
          },
        },
        axisLabel: {
          color: '#ccc',
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: '#ccc',
          },
        },
        axisLabel: {
          color: '#ccc',
        },
        splitLine: {
          lineStyle: {
            color: '#555',
            type: 'dashed',
          },
        },
      },
      series: [
        {
          name: '数量',
          type: 'bar',
          data: [20, 18, 30, 25, 15, 30], // 数据可以根据实际需求调整
          itemStyle: {
            color: '#b38a64', // 自定义柱状图颜色
            borderRadius: [7, 7, 0, 0], // 设置圆角，左上和右上圆角为5px
          },
          barWidth: '15px', // 柱子的宽度
        },
      ],
    };
    deviceTypeChart.setOption(option);
  }
}
